import React, { useState, useEffect } from "react";
import { SHARE_FUNCTIONS } from "../utils/constants/apiUrl";
import { get } from "../server";
import showToast from "../helpers/showToast";
import Loader from "../components/Loader";
import { useParams } from "react-router-dom";
import PublicCard from "./PublicCard";
import PublicEmergencyContact from "./PublicEmergencyContact";
import PublicProfile from "./PublicProfile";
import PublicDynamicQR from "./PublicDynamicQR";
import { AddMoreCustomUrls } from "../utils/data/CardFunctionsData";
import PublicContact from "./PublicContact";
import PublicFormBuilder from "./PublicFormBuilder";
import PublicMemory from "./PublicMemory";
import PublicMedicalID from "./PublicMedicalID";

function PublicFunctionsQR() {
  const [loading, setLoading] = useState(true);
  const [emergencyContact, setEmergencyContact] = useState({});
  const [profile, setProfile] = useState({});
  const [dynamicQR, setDynamicQR] = useState({});
  const [formBuilderData, setFormBuilderData] = useState({});
  const [memoryData, setMemoryData] = useState({});
  const [medicalIDData, setMedicalIDData] = useState({});
  const [cardFunction, setCardFunction] = useState({
    card_type: "",
    first_name: "",
    last_name: "",
    email: "",
    company: "",
    company_position: "",
    logo: "",
    background_image: "",
    profile_image: "",
    color: "",
    country_phone: "",
    phone_number: "",
    description: "",
    address: "",
    country: "",
    city: "",
    state: "",
    website_url: "",
    card_social_media: [],
    pronouns: "",
    card_phone: [{ phone_type: "", country_phone: "", phone_number: "" }],
    contact_card_other_data: [],
    content_view_type: "",
    profile_image_shape: "",
    card_form_builder: [],
    id: "",
    contact_exchange_form_status: "",
    contact_exchange_form_status_team: "",
    team_id: "",
  });

  const { functionType, uuid } = useParams();

  const loadPublicFunctions = async () => {
    let { status, message, data } = await get(
      `${SHARE_FUNCTIONS}${functionType}/${uuid}`
    );

    if (status) {
      if (functionType === "card" || functionType === "contact") {
        if (functionType === "contact") {
          data = data.contactCard;
        }
        let card_social_media = [];

        data?.cardSocialMedia?.forEach((item) => {
          let foundIcon = AddMoreCustomUrls.find(
            (single) =>
              single.name === item.media_type ||
              single.oldName === item.media_type
          );

          card_social_media.push({
            media_type: item.media_type,
            url: item.url,
            icon: item.media_type === "custom" ? "custom" : foundIcon?.icon,
            custom_label: item.custom_label,
          });
        });
        const teamBranding =
          data?.team || data?.team_detail || data?.team_branding || {
          logo: data?.team_logo || "",
          card_background_image: data?.card_background_image || "",
          card_color: data?.card_color || "",
        };
        if (functionType === "contact") {
          setCardFunction({
            card_type: data.card_type,
            first_name: data.first_name ? data.first_name : "",
            last_name: data.last_name ? data.last_name : "",
            email: data.email ? data.email : "",
            company: data.company ? data.company : "",
            company_position: data.company_position
              ? data.company_position
              : "",
            logo: data.logo ? data.logo : "",
            background_image: data.background_image
              ? data.background_image
              : "",
            profile_image: data.profile_image ? data.profile_image : "",
            color: data.color ? data.color : "",
            country_phone: data.country_phone ? `+${data.country_phone}` : "",
            phone_number: data.contact_card_phone.phone_number
              ? `${
                  data.contact_card_phone.country_phone
                    ? data.contact_card_phone.country_phone
                    : ""
                }${data.contact_card_phone.phone_number}`
              : "",
            description: data.description ? data.description : "",
            address: data.address ? data.address : "",
            country: data.country ? data.country : "",
            city: data?.city ? data?.city : "",
            state: data.state ? data.state : "",
            website_url: data.website_url ? data.website_url : "",
            card_social_media: card_social_media,
            pronouns: data.pronouns ? data.pronouns : "",
            card_phone: data.contact_card_phone,
            contact_card_other_data: data?.contact_card_other_data,
            content_view_type: data?.content_view_type
              ? data?.content_view_type
              : "",
            profile_image_shape: data?.profile_image_shape
              ? data?.profile_image_shape
              : "",
            logo_shape: data?.logo_shape ? data.logo_shape : "",
            card_form_builder: data?.card_form_builder
              ? data?.card_form_builder
              : [],
            id: data?.id,
            contact_exchange_form_status: data?.contact_exchange_form_status,
            contact_exchange_form_status_team:
              data?.contact_exchange_form_status_team,
            team_id: data?.team_id,
            team: teamBranding,
          });
        } else {
          setCardFunction({
            card_type: data.card_type,
            first_name: data.first_name ? data.first_name : "",
            last_name: data.last_name ? data.last_name : "",
            email: data.email ? data.email : "",
            company: data.company ? data.company : "",
            company_position: data.company_position
              ? data.company_position
              : "",
            logo: data.logo ? data.logo : "",
            background_image: data.background_image
              ? data.background_image
              : "",
            profile_image: data.profile_image ? data.profile_image : "",
            color: data.color ? data.color : "",
            country_phone: data.country_phone ? `+${data.country_phone}` : "",
            phone_number: data.phone_number
              ? `${data.country_phone ? data.country_phone : ""}${
                  data.phone_number
                }`
              : "",
            description: data.description ? data.description : "",
            address: data.address ? data.address : "",
            country: data.country ? data.country : "",
            city: data?.city ? data?.city : "",
            state: data.state ? data.state : "",
            website_url: data.website_url ? data.website_url : "",
            card_social_media: card_social_media,
            pronouns: data.pronouns ? data.pronouns : "",
            card_phone: data.cardPhone,
            content_view_type: data?.content_view_type
              ? data?.content_view_type
              : "",
            profile_image_shape: data?.profile_image_shape
              ? data?.profile_image_shape
              : "",
            logo_shape: data?.logo_shape ? data.logo_shape : "",
            card_form_builder: data?.card_form_builder
              ? data?.card_form_builder
              : [],
            id: data?.id,
            contact_exchange_form_status: data?.contact_exchange_form_status,
            contact_exchange_form_status_team:
              data?.contact_exchange_form_status_team,
            team_id: data?.team_id,
            team: teamBranding,
          });
        }
      } else if (functionType === "emergencyContact") {
        setEmergencyContact(data);
      } else if (
        functionType === "profile_personal" ||
        functionType === "profile_owner" ||
        functionType === "admin_qr_code"
      ) {
        setProfile(data);
      } else if (functionType === "dynamic_qr_code") {
        setDynamicQR(data);
      } else if (functionType === "form_builder") {
        setFormBuilderData(data);
      } else if (functionType === "memory") {
        setMemoryData(data);
      } else if (functionType === "medical_id") {
        setMedicalIDData(data);
      } else if (functionType === "fileUpload") {
        window.location.replace(data?.url_path);
      } else {
        window.location.replace(data?.url_path);
      }
    } else {
      showToast(status, message);
    }

    setLoading(false);
  };

  useEffect(() => {
    loadPublicFunctions();
  }, []);

  // if (loading) {
  //   return <Loader />;
  // }

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <>
          {functionType === "card" || functionType === "contact" ? (
            <div
              className="py-5"
              style={{
                backgroundColor: "var(--secondary_Color)",
                minHeight: "100vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {functionType === "card" ? (
                <PublicCard cardFunction={cardFunction} />
              ) : (
                <PublicContact cardFunction={cardFunction} />
              )}
            </div>
          ) : functionType === "emergencyContact" ? (
            <PublicEmergencyContact emergencyContact={emergencyContact} />
          ) : functionType === "profile_personal" ||
            functionType === "profile_owner" ||
            functionType === "admin_qr_code" ? (
            <PublicProfile profile={profile} />
          ) : functionType === "dynamic_qr_code" ? (
            <PublicDynamicQR dynamicQR={dynamicQR} />
          ) : functionType === "form_builder" ? (
            <PublicFormBuilder formBuilderData={formBuilderData} />
          ) : functionType === "memory" ? (
            <PublicMemory memoryData={memoryData} />
          ) : functionType === "medical_id" ? (
            <PublicMedicalID medicalIDData={medicalIDData} />
          ) : null}
        </>
      )}
    </>
  );
}

export default PublicFunctionsQR;
